import { debounce } from 'lodash'

import { generateRegExpFromString } from '@sigmasms/commons'

import { checkLegacyCondition, components, proxy, services, states } from '@/utils'

import { baseClass, ruleTags } from '@/components/rules/utils'

import render from './render'

export default {
  name: 'RulesDialogAdditional',

  mixins: [ proxy() ],

  props: {
    tag: String,

    readonly: Boolean
  },

  data() {
    return {
      loading: false,
      pattern: undefined,
      text: undefined,
      phone: undefined,
      state: undefined,
      error: undefined
    }
  },

  computed: {
    $_component() {
      switch (this.tag) {
        case ruleTags.text: return components.textarea
        case ruleTags.group:
        case ruleTags.contactList: return components['text-field']
      }
    },

    $_props() {
      const result = {
        dense: true,
        clearable: true,
        details: false
      }

      let textState
      if (this.text) {
        textState = states.error
        if (this.checkPattern()) {
          textState = states.success
        }
      }

      const propsByTag = {
        [ruleTags.text]: {
          value: this.text,
          label: this.getTranslate(`${baseClass}.labels.textToCheck`),
          state: textState,
          error: this.error,
          rows: 4,
          grow: true
        },
        [ruleTags.group]: {
          value: this.pattern,
          label: this.getTranslate(`${baseClass}.labels.group.pattern`)
        },
        [ruleTags.contactList]: {
          value: this.phone,
          label: this.getTranslate(`${baseClass}.labels.phone`),
          hint: this.getTranslate(`${baseClass}.hints.phone`),
          state: this.state,
          error: this.error,
          loading: this.loading,
          details: true
        }
      }

      return Object.assign(result, propsByTag[this.tag])
    },

    $_on() {
      return {
        input: this.eventHandler
      }
    }
  },

  watch: {
    proxy: {
      handler() {
        this.checkPhone()
      },
      deep: true
    },
    phone() {
      this.checkPhone()
    }
  },

  methods: {
    checkPattern() {
      if (this.tag === ruleTags.text) {
        if (this.text) {
          try {
            const pattern = generateRegExpFromString(this.proxy)

            return pattern.test(this.text)
          } catch (error) {
            this.error = this.getTranslate(`${services.routingRules}.errors.regexp`)

            return false
          }
        }

        return true
      }
    },

    checkPhone: debounce(async function() {
      if (this.phone) {
        try {
          this.loading = true
          let recipient = `+${this.phone}`
          if (this.phone.startsWith('+')) {
            recipient = this.phone
          }

          const result = await checkLegacyCondition({
            tag: this.tag,
            value: this.value
          },
          {
            payload: {
              recipient
            }
          })
          if (result) {
            this.state = states.success
            this.error = undefined
          } else {
            this.state = states.error
            this.error = this.getTranslate(`${services.routingRules}.errors.phone`)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.state = undefined
        this.error = undefined
      }
    }, 500, {
      leading: false,
      trailing: true
    }),

    eventHandler(value) {
      switch (this.tag) {
        case ruleTags.text: {
          this.text = value
          break
        }
        case ruleTags.group: {
          this.pattern = value
          break
        }
        case ruleTags.contactList: {
          this.phone = value
          break
        }
      }
    },

    reset() {
      this.text = undefined
      this.pattern = undefined
      this.phone = undefined
      this.state = undefined
      this.error = undefined
    }
  },

  render
}
